import { emailAxios } from '@/helpers/common/axios';

export default class ReportPreviewApi {
  constructor() {
    this.serverLink = global.conf.ENV_ENDPOINT_EMAIL_MASIV;
    this.serverLinkLambda = global.conf.ENV_ENDPOINT_LAMBDA_HEADERS;
  }

  getPreviewDetail(payload, isLoading, isLambda = false) {
    const customUrl = isLambda ? this.serverLinkLambda : this.serverLink;

    return emailAxios({
      method: 'POST',
      url: `${customUrl}/preview-email-detail-headers`,
      data: payload,
      isPosting: isLoading,
    });
  }

  getPreviewBody(payload, isLoading) {
    return emailAxios({
      method: 'POST',
      url: `${this.serverLink}/preview-email-body`,
      data: payload,
      isPosting: isLoading,
    });
  }
}
